import { render, staticRenderFns } from "./other-properties-page.vue?vue&type=template&id=8ffeb782&scoped=true"
import script from "./other-properties-page.vue?vue&type=script&lang=ts"
export * from "./other-properties-page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffeb782",
  null
  
)

export default component.exports